/**
 * Calculate percentage with safe division by zero handling
 *
 * @param part - The numerator value
 * @param total - The denominator value
 * @returns Rounded percentage (0-100) or 0 if total is 0
 */
export const calculatePercentage = (part: number, total: number): number => {
  return total !== 0 ? Math.round((part / total) * 100) : 0;
};
